module.exports = __webpack_public_path__ + "static/media/TJ.6427b93b.png";